import styled, {css} from 'styled-components';

import {center} from '../../styles/mixins';
import {ThemeContextType} from '../../theme/userThemeProvider';
import {isVariantWithBorder} from './buttonConstants';
import {ButtonContent, ButtonContentProps} from './buttonContent';

/*
 * Style.
 */

const StyledButtonContent = styled(ButtonContent)`
  ${center()};
  padding: 0 12px 0 8px;
  position: relative;

  ${(p) => addSeparatorStyles(p)};
`;

// Use a pseudo element because we don't want the separator to overlap with the button border.
// - Leave 1px so we don't draw over the border (only if the variant has a border).
// - "left: -2px" so the separator highlights when the button is hovered.
function addSeparatorStyles(props: ButtonContentProps & ThemeContextType) {
  const chevronColor = props.theme.border.alpha;
  const hasBorder = isVariantWithBorder(props.variant);
  const topBottom = hasBorder ? '1px' : '0';

  return css`
    &:before {
      content: '';
      position: absolute;
      left: -1px;
      top: ${topBottom};
      bottom: ${topBottom};
      width: 1px;
      background-color: ${chevronColor};
    }
  `;
}

/*
 * Component.
 */

export const ButtonChevronContent = StyledButtonContent;
